import { genericPost, genericGet } from '../apiService';
import { API_URL } from '../../config/env';

class NotificationService {
  async getNotificationSettings() {
    try {
      console.log("API URL:", `${API_URL}NotificationSettings/GetUserSettings`);
      const response = await genericGet(`${API_URL}NotificationSettings/GetUserSettings`);
      console.log("API yanıtı:", response);
      
      // API'den gelen veriyi dönüştürme
      let transformedData = undefined;
      
      if (response.data) {
        console.log("API'den gelen ham veri:", response.data);
        
        // Tüm API verilerini içeren genişletilmiş format
        transformedData = {
          // Ana bildirim kanalları
          emailNotifications: response.data.emailNotificationsEnabled || false,
          smsNotifications: response.data.smsNotificationsEnabled || false,
          pushNotifications: response.data.pushNotificationsEnabled || false,
          
          // E-posta alt kategorileri
          emailCategories: {
            dailyDigest: response.data.emailDailyDigest || false,
            marketing: response.data.emailMarketing || false,
            security: response.data.emailSecurity || false
          },
          
          // SMS alt kategorileri
          smsCategories: {
            marketing: response.data.smsMarketing || false,
            security: response.data.smsSecurity || false
          },
          
          // Bildirim kategorileri
          notificationCategories: {
            messages: response.data.pushNewMessage || false,
            activity: response.data.pushNewActivity || false,
            systemUpdates: response.data.notifyOnSystemUpdates || false,
            promotions: response.data.notifyOnPromotions || false,
            newsAndAnnouncements: response.data.notifyOnNewsletter || false,
            accountActivity: response.data.notifyOnAccountActivity || false
          },
          
          // Cihaz bilgileri
          deviceInfo: {
            token: response.data.deviceToken || "",
            platform: response.data.devicePlatform || ""
          }
        };
        
        console.log("Dönüştürülmüş veri:", transformedData);
      } else {
        console.warn("API yanıtında veri yok veya geçersiz:", response);
      }
      
      return {
        statusCode: response.statusCode,
        data: transformedData,
        message: response.message
      };
    } catch (error) {
      console.error("Bildirim ayarları alınırken hata:", error);
      return {
        statusCode: 500,
        data: undefined,
        message: "Bildirim ayarları alınırken bir hata oluştu"
      };
    }
  }

  async updateNotificationSettings(settings) {
    try {
      // API'nin beklediği formata dönüştürme
      const apiSettings = {
        // Ana bildirim kanalları
        emailNotificationsEnabled: settings.emailNotifications,
        smsNotificationsEnabled: settings.smsNotifications,
        pushNotificationsEnabled: settings.pushNotifications,
        
        // E-posta alt kategorileri
        emailDailyDigest: settings.emailCategories?.dailyDigest || false,
        emailMarketing: settings.emailCategories?.marketing || false,
        emailSecurity: settings.emailCategories?.security || false,
        
        // SMS alt kategorileri
        smsMarketing: settings.smsCategories?.marketing || false,
        smsSecurity: settings.smsCategories?.security || false,
        
        // Bildirim kategorileri
        pushNewMessage: settings.notificationCategories?.messages || false,
        pushNewActivity: settings.notificationCategories?.activity || false,
        notifyOnSystemUpdates: settings.notificationCategories?.systemUpdates || false,
        notifyOnPromotions: settings.notificationCategories?.promotions || false,
        notifyOnNewsletter: settings.notificationCategories?.newsAndAnnouncements || false,
        notifyOnAccountActivity: settings.notificationCategories?.accountActivity || false,
        
        // Cihaz bilgileri - genellikle bu değerler sadece okunur
        deviceToken: settings.deviceInfo?.token || "",
        devicePlatform: settings.deviceInfo?.platform || ""
      };
      
      console.log("API'ye gönderilen ayarlar:", apiSettings);
      
      const response = await genericPost(`${API_URL}NotificationSettings/UpdateSettings`, apiSettings);
      return {
        statusCode: response.statusCode,
        data: undefined,
        message: response.message
      };
    } catch (error) {
      console.error("Bildirim ayarları güncellenirken hata:", error);
      return {
        statusCode: 500,
        data: undefined,
        message: "Bildirim ayarları güncellenirken bir hata oluştu"
      };
    }
  }
}

export const notificationService = new NotificationService(); 